import { useEnterpriseNavigate } from '@mews-commander/ui';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { getSelectedServiceId } from '@mews-commander/legacy-entities/src/ducks/serviceSelect';
import ConnectedPieChart, { ConnectedPieChartProps } from '../../charts/PieChart/ConnectedPieChart';
import { trackDashboardPieClick } from '../actions/util';

interface ArrivingProfilesStatisticsChartProps extends Pick<ConnectedPieChartProps, 'data'> {
    isAccessible: boolean;
    dataTestId: string;
    isLoading: boolean;
}

export const ArrivingProfilesStatisticsChart = ({
    isAccessible,
    dataTestId,
    data,
    isLoading,
}: ArrivingProfilesStatisticsChartProps) => {
    const dispatch = useCommanderThunkDispatch();
    const serviceId = useCommanderSelector(getSelectedServiceId);
    const navigate = useEnterpriseNavigate();

    const onClick = () => {
        if (!isAccessible) {
            return null;
        }

        dispatch(trackDashboardPieClick('ArrivingProfilesStatisticsChart'));
        void navigate({
            to: 'CustomerProfileReport/Index',
            search: {
                Mode: 'Arrival',
                'Service.Id': serviceId,
            },
        });
    };

    return <ConnectedPieChart data={data} showLoader={isLoading} onClick={onClick} dataTestId={dataTestId} />;
};
